<template>
  <div>
    <!-- <empty-box class="query-form">
      <a-form-model :model="searchForm" layout="inline" ref="searchForm">
        <a-form-model-item label="申请人" prop="orderId">
          <a-input v-model="searchForm.orderId" placeholder="请输入申请人" allowClear />
        </a-form-model-item>
        <a-form-model-item label="时间" prop="orderId">
          <a-input v-model="searchForm.orderId" placeholder="请输入订单编号" allowClear />
        </a-form-model-item>
        <a-form-model-item label="审核状态" prop="invoiceStatus">
          <a-select v-model="searchForm.invoiceStatus" placeholder="请选择" class="w140" @change="handleQuery">
            <a-select-option value="0">审核中</a-select-option>
            <a-select-option value="1">通过</a-select-option>
            <a-select-option value="2">不通过</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item>
          <a-button type="primary" @click="handleQuery">查询</a-button>
        </a-form-model-item>
        <a-form-model-item>
          <a-button @click="resetForm">重置</a-button>
        </a-form-model-item>
      </a-form-model>
    </empty-box> -->

    <a-table 
        :columns="columns"
        :data-source="list"
        bordered 
        :pagination="false"
        :rowKey="record => record.id"
        class="table-list">
      <span slot="updateTime" slot-scope="text">{{ moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
      <span slot="titleType" slot-scope="text">{{ titleTypeList[text] }}</span>
      <span slot="invoiceType" slot-scope="text">{{ text == 0 ? '普通发票' : '专用发票' }}</span>
      <template slot="auditStatus" slot-scope="text">
        <a-tag :color="statusList[text].color">{{ statusList[text].text }}</a-tag>
      </template>
      
      <span slot="action" slot-scope="record">
        <a-button type="link" @click="handleDetail(record)" v-if="record.auditStatus != 0">详情</a-button>
        <a-button type="link" @click="handleDetail(record)" v-if="record.auditStatus == 0">审核</a-button>
      </span>
    </a-table>

    <a-modal
      v-model="visible"
      title="审核信息"
      width="1000px"
      :footer="detail.auditStatus !== 0 ? null : undefined">
      <template slot="footer">
        <a-button type="danger" @click="handelReject">拒绝</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOk">通过</a-button>
      </template>
      <div>
        <a-form layout="horizontal" class="info" :label-col="{ span: 3 }" :wrapper-col="{ span: 12 }">
          <a-form-item label="审核状态">
            <a-tag :color="statusList[detail.auditStatus] ? statusList[detail.auditStatus].color : ''">{{ statusList[detail.auditStatus] ? statusList[detail.auditStatus].text : '' }}</a-tag>
          </a-form-item>
          <a-form-item label="发票抬头">
            <span>{{ detail.invoiceTitle }}</span>
          </a-form-item>
          <a-form-item label="抬头类型">
            <span>{{ titleTypeList[detail.titleType] }}</span>
          </a-form-item>
          <a-form-item label="发票类型">
            <span>{{ detail.invoiceType == 0 ? '普通发票' : '专用发票' }}</span>
          </a-form-item>
          <a-form-item label="统一社会信用代码">
            <span>{{ detail.taxNumber }}</span>
          </a-form-item>
          <a-form-item label="营业执照">
            <img v-if="detail.bizLicenseUrl" width="300" :src="`${host}${detail.bizLicenseUrl}`" alt="">
          </a-form-item>
          <a-form-item label="开户银行名称">
            <span>{{ detail.bankName }}</span>
          </a-form-item>
          <a-form-item label="基本开户账号">
            <span>{{ detail.bankAccount }}</span>
          </a-form-item>
          <a-form-item label="注册场所地址">
            <span>{{ detail.companyAddress }}</span>
          </a-form-item>
          <a-form-item label="注册固定电话">
            <span>{{ detail.companyPhone }}</span>
          </a-form-item>
          <a-form-item label="手机号">
            <span>{{ detail.receivePhone }}</span>
          </a-form-item>
          <a-form-item label="邮箱">
            <span>{{ detail.receiveEmail }}</span>
          </a-form-item>
        </a-form>
      </div>
    </a-modal>

    <a-modal
      title="审核"
      :visible="verifyFormVisible"
      :confirm-loading="confirmLoading"
      @ok="handelRejectOk"
      @cancel="verifyFormVisible = false"
    >
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 20 }"
      >
        <a-form-model-item label="拒绝理由" prop="remark">
          <a-input v-model="form.remark" type="textarea"/>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { queryInvoiceList, invoiceAudit } from '@/api/api'
import moment from 'moment'
const columns = [
  {
    title: '时间',
    dataIndex: 'updateTime',
    key: 'updateTime',
    align: 'center',
    scopedSlots: { customRender: 'updateTime' },
  },
  {
    title: '申请人',
    dataIndex: 'userRegisterPhone',
    key: 'userRegisterPhone',
    align: 'center'
  },
  {
    title: '发票抬头',
    dataIndex: 'invoiceTitle',
    key: 'invoiceTitle',
    align: 'center'
  },
  {
    title: '抬头类型',
    dataIndex: 'titleType',
    key: 'titleType',
    align: 'center',
    scopedSlots: { customRender: 'titleType' },
  },
  {
    title: '发票类型',
    dataIndex: 'invoiceType',
    key: 'invoiceType',
    align: 'center',
    scopedSlots: { customRender: 'invoiceType' },
  },
  {
    title: '审核状态',
    dataIndex: 'auditStatus',
    key: 'auditStatus',
    align: 'center',
    scopedSlots: { customRender: 'auditStatus' },
  },
  {
    title: '操作',
    key: 'action',
    align: 'center',
    scopedSlots: { customRender: 'action' },
  },
]

const detailColumns = [
  {
    title: '功能名称',
    dataIndex: 'functionName',
    key: 'functionName',
    align: 'center'
  },
  {
    title: '单价',
    dataIndex: 'permanentPrice',
    key: 'permanentPrice',
    align: 'center'
  },
  {
    title: '购买数量',
    dataIndex: 'goodsNumbers',
    key: 'goodsNumbers',
    align: 'center'
  },
  {
    title: '金额',
    dataIndex: 'price',
    key: 'price',
    align: 'center'
  },
]

const statusList = [
  {
    color: 'orange',
    text: '审核中'
  },
  {
    color: 'green',
    text: '通过'
  },
  {
    color: 'red',
    text: '不通过'
  },
]

const titleTypeList = ['个人', '企业', '事业单位']

export default {
  data() {
    return {
      moment,
      searchForm: {
        orderId: '',
        invoiceStatus: undefined,
      },
      columns,
      list: [],
      visible: false,
      detail: {},

      detailColumns,

      orderVisible: false,
      orderList: [],
      statusList,
      titleTypeList,
      loading: false,

      verifyFormVisible: false,
      confirmLoading: false,

      form: {
        remark: ''
      },

      rules: {
        remark: [{required: true, message: '请输入拒绝理由', trigger: 'blur'}]
      }
    }
  },

  computed: {
    host() {
        return window.location.origin
    }
  },

  methods: {

    getList() {
        queryInvoiceList().then(({ response }) => {
            this.list = response
            // .filter(item => item.invoiceType == 0)
        }) 
    },

    handleQuery() {
        this.getList()
    },

    resetForm() {
      this.$refs['searchForm'].resetFields()
      this.getList()
    },

    handleInvoice() {

    },

    // 查看详情
    handleDetail(row) {
      this.detail = Object.assign({}, row)
      
      this.$nextTick(() => {
        this.visible = true
      })
    },

    // 审核通过
    handleOk() {
        this.form.remark = ''
        this.check(1)
    },

    // 审核不通过
    handelReject() {
      this.verifyFormVisible = true

      this.$nextTick(() => {
        this.$refs['ruleForm'].clearValidate()
      })
    },

    handelRejectOk() {
        this.check(2)
    },

    check(status) {
        if (status == 1) {
            this.checkFn(status)
        } else {
            this.$refs['ruleForm'].validate(valid => {
                if (valid) {
                    this.checkFn(status)  
                } else {
                    return false
                }
            })
        }
    },

    checkFn(status) {
        const para = {
            invoiceId: this.detail.id,
            status: status,
            remark: this.form.remark
        }

        invoiceAudit(para).then(({ error, response }) => {
            if (error.code == 0) {
                this.$message.success(error.msg)
                this.verifyFormVisible = false
                this.visible = false
                this.getList()
            } else {
                this.$message.error(error.msg)
            }
            
        })
    }
  },

  created() {
    this.getList()
  }
}
</script>

<style lang="less" scoped>
  .info {
    padding: 0;
    /deep/ .ant-form-item {
      margin-bottom: 0;
    }
  }
</style>